<template>
	<v-container>
		<v-row align="center">
			<v-col cols="3">
				<v-img src="@/assets/ciclo-urbano.png" width="200px"></v-img>
			</v-col>
			<v-col cols="9" class="text-left overline">
				<div>
					UrbanPlagas SpA.
				</div>
				<div>
					Diseño, mantención de áreas verdes y manejo integral en control de plagas
				</div>
				<div>
					RUT: 76.693.777-2
				</div>
				<div>Clorinda Henriquez 99, La Reina, R.M.</div>
				<div>2 3217 22 11 / +56978901179</div>
				<a href="https://www.ciclourbano.cl" target="_blank" style="text-decoration: none">
					www.ciclourbano.cl
				</a>
			</v-col>
		</v-row>
		<v-row style="text-align: left; font-size: 11px !important;">
			<v-col cols="12">
				<v-row no-gutters>
					<v-col cols="4" md="4" style="text-align: left;">
						<p>
							Solicitado por:
							<input type="text" size="40" v-model="values[2]" />
						</p>
						<p>
							Rut:
							<input type="text" size="40" v-model="values[3]" />
						</p>
						<p>Dirección: <input type="text" v-model="values[4]" size="40" /></p>
						<p>Comuna / Ciudad: <input type="text" v-model="values[5]" size="40" /></p>
					</v-col>
					<v-col cols="4" md="4" style="text-align: left;">
						<p>Autorizado por: <input type="text" v-model="values[6]" size="40" /></p>
						<p>Rut: <input type="text" v-model="values[7]" size="40" /></p>
						<p>Dirección: <input type="text" v-model="values[8]" size="40" /></p>
						<p>Comuna / Ciudad: <input type="text" v-model="values[9]" size="40" /></p>
					</v-col>
					<v-col cols="4" md="4" style="text-align: left;">
						<!-- Posiblemente no se vaya a mostrar este campo en el formulario -->
						<!-- <p>Fecha: <input type="text" v-model="values[9]" size="40" /></p> -->
						<p>N° orden de trabajo: Aún sin asignar</p>
						<p>Dirección perimetral: {{ lodgingSelect.place.address }}</p>
						<p v-for="(email, index) in lodgingSelect.place.email" :key="index">
							Correo: {{ email }}
						</p>
						<p>
							Tecnico Encargdado: <input type="text" v-model="values[10]" size="40" />
						</p>
					</v-col>
				</v-row>
				<v-row no-gutters>
					<div class="body-2">Control de palomas</div>
					<v-col cols="12" style="text-align: left;">
						<input type="checkbox" v-model="values[11]" class="ma-2" />Mantencion
						<input type="checkbox" v-model="values[12]" class="ma-2 cot" />
						Asistencia
					</v-col>
					<v-col cols="12" style="text-align: left;">
						<input type="checkbox" v-model="values[13]" class="ma-2" />Perfiles
						Desestabilizadores
						<input type="checkbox" v-model="values[14]" class="ma-2 cot" />
						Pinchos Galvanizados
						<input type="checkbox" v-model="values[15]" class="ma-2 cot" />
						Malla Hexagonal
						<input type="checkbox" v-model="values[16]" class="ma-2 cot" />
						Malla Monofilamento
						<input type="checkbox" v-model="values[17]" class="ma-2 cot" />
						Espuma
					</v-col>
					<v-col cols="12" style="text-align: left;">
						Un
						<input type="text" v-model="values[18]" class="ma-2" size="1" />Hilos Un
						<input type="text" v-model="values[19]" class="ma-2" size="1" />Mts. Un
						<input type="text" v-model="values[20]" class="ma-2" size="1" />Hilos Un
						<input type="text" v-model="values[21]" class="ma-2" size="1" />
						<input type="text" v-model="values[22]" class="ma-2" size="1" />
					</v-col>
					<v-col cols="12" style="text-align: left;">
						<input type="checkbox" v-model="values[23]" class="ma-2" />Limpieza de
						canaleta
						<input type="checkbox" v-model="values[24]" class="ma-2 cot" />Entretecho
						<p class="ma-2">
							Observaciones: <input type="text" v-model="values[25]" size="100" />
						</p>
					</v-col>
				</v-row>
				<v-row no-gutters>
					<v-col cols="12">
						<div class="body-2">Sanitizacion</div>
						<input type="checkbox" v-model="values[26]" class="ma-2" /> Mantención
						<input type="checkbox" v-model="values[27]" class="ma-2 cot" />
						Asistencia <br />
						Producto:
						<input type="text" v-model="values[28]" size="40" /> Cantidad:
						<input type="text" v-model="values[29]" size="40" />

						Dosis: <input type="text" v-model="values[30]" size="40" />
					</v-col>
					<v-col cols="12" style="text-align: left;">
						<input type="checkbox" v-model="values[31]" class="ma-2 cot" />
						Baños
						<input type="checkbox" v-model="values[32]" class="ma-2 cot" />
						Cocina
						<input type="checkbox" v-model="values[33]" class="ma-2 cot" />
						Duchas/Camarines
						<input type="checkbox" v-model="values[34]" class="ma-2 cot" />
						Entretecho
					</v-col>
					<v-col cols="12" style="text-align: left;">
						<input type="checkbox" v-model="values[35]" class="ma-2 cot" />
						Vestidores
						<input type="checkbox" v-model="values[36]" class="ma-2 cot" />
						<input type="text" v-model="values[37]" size="40" />
						<input type="checkbox" v-model="values[38]" class="ma-2 cot" />
						<input type="text" v-model="values[39]" size="40" />
						<input type="checkbox" v-model="values[40]" class="ma-2 cot" />
						<input type="text" v-model="values[41]" size="40" />
						<p class="ma-2">
							Observaciones: <input type="text" v-model="values[42]" size="100" />
						</p>
					</v-col>
				</v-row>

				<v-row no-gutters>
					<v-col cols="12">
						<div class="body-2">Desratización</div>
						<input type="checkbox" v-model="values[43]" class="ma-2" /> Mantención
						<input type="checkbox" v-model="values[44]" class="ma-2" /> Asistencia
						<input type="checkbox" v-model="values[45]" class="ma-2 cot" />
						Monitoreo <br />
						I.A:
						<input type="text" v-model="values[46]" size="40" />
						Dosis: <input type="text" v-model="values[47]" size="40" />
					</v-col>
					<v-col cols="2" style="text-align: left;">
						<input type="checkbox" v-model="values[48]" class="ma-2 cot" />
						Borde Perimetral<br />
						<input type="checkbox" v-model="values[49]" class="ma-2 cot" />
						Entretecho<br />
						<input type="checkbox" v-model="values[50]" class="ma-2 cot" />
						Alcantarillado<br />
						<input type="checkbox" v-model="values[51]" class="ma-2 cot" />
						Cocina<br />
						<input type="checkbox" v-model="values[52]" class="ma-2 cot" />
						Oficinas<br />
						<input type="checkbox" v-model="values[53]" class="ma-2 cot" />
						Bodega<br />
						<input type="checkbox" v-model="values[54]" class="ma-2 cot" />
						Sala de Basura<br />
						<input type="checkbox" v-model="values[55]" class="ma-2 cot" />
						<input type="text" v-model="values[56]" size="20" /><br />
						<input type="checkbox" v-model="values[57]" class="ma-2 cot" />
						<input type="text" v-model="values[58]" size="20" /><br />
						<input type="checkbox" v-model="values[59]" class="ma-2 cot" />
						<input type="text" v-model="values[60]" size="20" /><br />
					</v-col>
					<v-col cols="10">
						<v-row>
							<v-col cols="3" md="3">
								<input type="checkbox" v-model="values[61]" class="ma-2 cot" />
								Caja Cebedera<br /><input
									type="text"
									size="20"
									v-model="values[62]"
								/>
							</v-col>
							<v-col cols="3" md="3">
								<input type="checkbox" v-model="values[63]" class="ma-2 cot" />
								Captura viva<br /><input
									type="text"
									size="20"
									v-model="values[64]"
								/>
							</v-col>
							<v-col cols="3" md="3">
								<input type="checkbox" v-model="values[65]" class="ma-2 cot" />
								Trampas pegajosas<br /><input
									type="text"
									size="20"
									v-model="values[66]"
								/>
							</v-col>
							<v-col cols="3" md="3">
								<input type="checkbox" v-model="values[67]" class="ma-2 cot" />
								Tubo cebadero<br /><input
									type="text"
									size="20"
									v-model="values[68]"
								/>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="3" md="3">
								<input
									type="checkbox"
									v-model="values[69]"
									class="ma-2 cot"
								/><input type="text" size="10" v-model="values[70]" /> <br /><input
									type="text"
									size="20"
									v-model="values[71]"
								/>
							</v-col>
							<v-col cols="3" md="3">
								<input
									type="checkbox"
									v-model="values[72]"
									class="ma-2 cot"
								/><input type="text" size="10" v-model="values[73]" /> <br /><input
									type="text"
									size="20"
									v-model="values[74]"
								/>
							</v-col>
							<v-col cols="3" md="3">
								<input type="checkbox" v-model="values[75]" class="ma-2 cot" />
								Cebos repuesto<br /><input
									type="text"
									size="20"
									v-model="values[76]"
								/>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="12" class="my-2">
						Observaciones: <input type="text" v-model="values[77]" size="100" />
					</v-col>
				</v-row>
				<v-row no-gutters>
					<v-col cols="12">
						<div class="body-2">Desinsectación</div>
						<input type="checkbox" v-model="values[78]" class="ma-2" /> Mantención
						<input type="checkbox" v-model="values[79]" class="ma-2 cot" />
						Asistencia <br />
						Producto:
						<input type="text" v-model="values[80]" size="40" /> Cantidad:
						<input type="text" v-model="values[81]" size="40" />

						Dosis: <input type="text" v-model="values[82]" size="40" />
					</v-col>
					<v-col cols="2" style="text-align: left;">
						<input type="checkbox" v-model="values[83]" class="ma-2 cot" />
						Baños<br />
						<input type="checkbox" v-model="values[84]" class="ma-2 cot" />
						Oficinas<br />
						<input type="checkbox" v-model="values[85]" class="ma-2 cot" />
						Casino/comedor<br />
						<input type="checkbox" v-model="values[86]" class="ma-2 cot" />
						Interior<br />
						<input type="checkbox" v-model="values[87]" class="ma-2 cot" />
						Exterior<br />
						<input type="checkbox" v-model="values[88]" class="ma-2 cot" />
						Insectos voladores<br />
						<input type="checkbox" v-model="values[89]" class="ma-2 cot" />
						Insectos rastreros<br />
					</v-col>
					<v-col cols="2">
						<input type="checkbox" v-model="values[90]" class="ma-2 cot" />
						Cocina<br />
						<input type="checkbox" v-model="values[91]" class="ma-2 cot" />
						Bodegas<br />
						<input type="checkbox" v-model="values[92]" class="ma-2 cot" />
						Sala de basura<br />
						<input type="checkbox" v-model="values[93]" class="ma-2 cot" />
						<input type="text" v-model="values[94]" size="20" /><br />
					</v-col>
					<v-col cols="2">
						<input type="checkbox" v-model="values[95]" class="ma-2 cot" />
						Duchas/Camarines<br />
						<input type="checkbox" v-model="values[96]" class="ma-2 cot" />
						Habitacion<br />
						<input type="checkbox" v-model="values[97]" class="ma-2 cot" />
						Sala de Espera/Sala de ventas<br />
						<input type="checkbox" v-model="values[98]" class="ma-2 cot" />
						<input type="text" v-model="values[99]" size="20" /><br />
					</v-col>
					<v-col cols="2">
						<input type="checkbox" v-model="values[100]" class="ma-2 cot" />
						Entretecho<br />
						<input type="checkbox" v-model="values[101]" class="ma-2 cot" />
						Borde Perimetral<br />
						<input type="checkbox" v-model="values[102]" class="ma-2 cot" />
						Hall de acceso<br />
						<input type="checkbox" v-model="values[103]" class="ma-2 cot" />
						<input type="text" v-model="values[104]" size="20" /><br />
					</v-col>
					<v-col cols="12" class="my-2">
						Observaciones: <input type="text" v-model="values[105]" size="100" />
					</v-col>
				</v-row>
				<v-row no-gutters>
					<v-col cols="12">
						<div class="body-2">Otros</div>
						<input type="checkbox" v-model="values[106]" class="ma-2" /> Mantención
						<input type="checkbox" v-model="values[107]" class="ma-2 cot" />
						Asistencia
					</v-col>
					<v-col cols="12" style="text-align: left;">
						<v-row no-gutters>
							<v-col cols="12" md="4" xl="3" style="text-align: left;">
								<input type="checkbox" v-model="values[108]" class="ma-2 cot" />
								<input type="text" v-model="values[109]" size="20" /><br />
								<br />
								<input
									type="text"
									v-model="values[110]"
									size="40"
									class="ma-2 cf"
								/>
								<input
									type="text"
									v-model="values[111]"
									size="40"
									class="ma-2 cf"
								/>
								<input
									type="text"
									v-model="values[112]"
									size="40"
									class="ma-2 cf"
								/>
							</v-col>

							<v-col cols="12" md="4" xl="3" style="text-align: left;">
								<input type="checkbox" v-model="values[113]" class="ma-2 cot" />
								<input type="text" v-model="values[114]" size="20" /><br />
								<br />
								<input
									type="text"
									v-model="values[115]"
									size="40"
									class="ma-2 cf"
								/>
								<input
									type="text"
									v-model="values[116]"
									size="40"
									class="ma-2 cf"
								/>
								<input
									type="text"
									v-model="values[117]"
									size="40"
									class="ma-2 cf"
								/>
							</v-col>
						</v-row>

						<p class="ma-2">
							Observaciones: <input type="text" v-model="values[118]" size="100" />
						</p>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
		<v-row justify="center">
			<v-col cols="12" class="mb-3">
				<h4>Validar OT con foto (No se podrá modificar luego).</h4>
				<input
					id="image-up"
					type="file"
					accept="image/*"
					capture="camera"
					style="border: none"
					class="ma-2"
					@change="setImage"
				/>
			</v-col>
			<v-col cols="12" sm="7">
				<p class="ma-2">
					Correo:
					<br />
					<input type:="email" v-model="values[121]" size="50"/>
				</p>
			</v-col>
			<v-col cols="12" sm="7">
				<v-btn
					:loading="loading"
					class="ma-1"
					small
					outlined
					color="black"
					@click="onSubmit"
				>
					Guardar y enviar correo
				</v-btn>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { capitalize } from 'lodash';
export default {
	props: {
		close: {
			type: Function,
			required: true,
		},
		idLodging: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			loading: false,
			image: null,
			values: [],
		};
	},
	computed: {
		...mapGetters({
			lodgingSelect: 'Lodging/lodgingSelect',
			person: 'Person/person',
		}),
	},
	created() {
		this.setValuesDefault();
	},
	methods: {
		async onSubmit() {
			this.loading = true;
			this.values[119] = new Date();
			// this.values[120] reservado para la imagen
			// this.values[121] reservado para el correo
			this.values[122] = 'urban-plagas';
			const data = JSON.stringify(this.values);
			const payload = new FormData();
			payload.append('image', this.image);
			payload.append('values', data);

			await this.createWorkOrder({
				idLodging: this.idLodging,
				payload,
			});
			this.values = [];
			this.image = null;
			document.getElementById('image-up').value = null;
			this.loading = false;
			this.close();
		},
		setImage(event) {
			this.image = event.target.files[0];
		},
		setValuesDefault() {
			for (var i = 0; i < 122; i++) {
				this.values.push(null);
			}
			this.values[2] = capitalize(this.lodgingSelect.place.name);
			this.values[3] = this.lodgingSelect.place.rut;
			this.values[4] = this.lodgingSelect.place.direction;
			this.values[5] = this.lodgingSelect.place.city;
			this.values[10] = `${capitalize(this.person.firstName)} ${
				this.person.lastName ? capitalize(this.person.lastName) : ''
			}`;
		},
		...mapMutations({ setLodgingSelect: 'Lodging/setLodgingSelect' }),
		...mapActions({ createWorkOrder: 'Lodging/createWorkOrder' }),
	},
};
</script>

<style lang="scss" scoped>
input {
	border-bottom: 1px solid black;
}
.cf {
	border: 1px solid black;
	margin-bottom: 1px;
	border-radius: 3px;
}
</style>
